var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.onboardingSeekingOptionsVisible)?_c('div',[_c('onboarding-seeking-options')],1):_c('div',[_c('onboarding-seeking-selector')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }